/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2dMe7XWUq916KsPnra5vYj
// Component: _c0HP8vrOTq

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  generateStateOnChangeProp,
  generateStateValueProp,
  renderPlasmicSlot,
  StrictProps,
  useDollarState,
  useTrigger,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import Select from "../../components/widgets/Select"; // plasmic-import: j_4IQyOWK2b/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_end_user_management.css"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/projectcss
import sty from "./PlasmicDirectoryUserRow.module.css"; // plasmic-import: _c0HP8vrOTq/css

import TrashIcon from "../plasmic_kit/PlasmicIcon__Trash"; // plasmic-import: 7bxap5bzcUODa/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon
import PlusSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__PlusSvg"; // plasmic-import: sQKgd2GNr/icon

createPlasmicElementProxy;

export type PlasmicDirectoryUserRow__VariantMembers = {};
export type PlasmicDirectoryUserRow__VariantsArgs = {};
type VariantPropType = keyof PlasmicDirectoryUserRow__VariantsArgs;
export const PlasmicDirectoryUserRow__VariantProps =
  new Array<VariantPropType>();

export type PlasmicDirectoryUserRow__ArgsType = { userEmail?: React.ReactNode };
type ArgPropType = keyof PlasmicDirectoryUserRow__ArgsType;
export const PlasmicDirectoryUserRow__ArgProps = new Array<ArgPropType>(
  "userEmail"
);

export type PlasmicDirectoryUserRow__OverridesType = {
  root?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  groupsSelect?: Flex__<typeof Select>;
  deleteBtn?: Flex__<typeof IconButton>;
};

export interface DefaultDirectoryUserRowProps {
  userEmail?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicDirectoryUserRow__RenderFunc(props: {
  variants: PlasmicDirectoryUserRow__VariantsArgs;
  args: PlasmicDirectoryUserRow__ArgsType;
  overrides: PlasmicDirectoryUserRow__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "groupsSelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover,
  };

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_2dMe7XWUq916KsPnra5vYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      <div className={classNames("all", sty.column___5J5Ef)}>
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames("all", sty.freeBox)}
        >
          {renderPlasmicSlot({
            defaultContents: "user@plasmic.app",
            value: args.userEmail,
            className: classNames(sty.slotTargetUserEmail),
          })}
        </div>
      </div>
      <div className={classNames("all", sty.column__eMzMk)}>
        <Select
          data-plasmic-name={"groupsSelect"}
          data-plasmic-override={overrides.groupsSelect}
          className={classNames("__wab_instance", sty.groupsSelect)}
          icon={
            <PlusSvgIcon
              className={classNames("all", sty.svg__l8SIk)}
              role={"img"}
            />
          }
          onChange={async (...eventArgs: any) => {
            ((...eventArgs) => {
              generateStateOnChangeProp($state, ["groupsSelect", "value"])(
                eventArgs[0]
              );
            }).apply(null, eventArgs);

            if (
              eventArgs.length > 1 &&
              eventArgs[1] &&
              eventArgs[1]._plasmic_state_init_
            ) {
              return;
            }
          }}
          value={generateStateValueProp($state, ["groupsSelect", "value"])}
        />
      </div>
      <div className={classNames("all", sty.column__yrFC)}>
        <IconButton
          data-plasmic-name={"deleteBtn"}
          data-plasmic-override={overrides.deleteBtn}
          children2={
            <ChevronDownSvgIcon
              className={classNames("all", sty.svg__zQhvK)}
              role={"img"}
            />
          }
          className={classNames("__wab_instance", sty.deleteBtn)}
        >
          <TrashIcon
            className={classNames("all", sty.svg__c1EcA)}
            role={"img"}
          />
        </IconButton>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "groupsSelect", "deleteBtn"],
  freeBox: ["freeBox"],
  groupsSelect: ["groupsSelect"],
  deleteBtn: ["deleteBtn"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  groupsSelect: typeof Select;
  deleteBtn: typeof IconButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDirectoryUserRow__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDirectoryUserRow__VariantsArgs;
    args?: PlasmicDirectoryUserRow__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicDirectoryUserRow__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicDirectoryUserRow__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDirectoryUserRow__ArgProps,
          internalVariantPropNames: PlasmicDirectoryUserRow__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicDirectoryUserRow__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDirectoryUserRow";
  } else {
    func.displayName = `PlasmicDirectoryUserRow.${nodeName}`;
  }
  return func;
}

export const PlasmicDirectoryUserRow = Object.assign(
  // Top-level PlasmicDirectoryUserRow renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    groupsSelect: makeNodeComponent("groupsSelect"),
    deleteBtn: makeNodeComponent("deleteBtn"),

    // Metadata about props expected for PlasmicDirectoryUserRow
    internalVariantProps: PlasmicDirectoryUserRow__VariantProps,
    internalArgProps: PlasmicDirectoryUserRow__ArgProps,
  }
);

export default PlasmicDirectoryUserRow;
/* prettier-ignore-end */
